export const ENDPOINTS = {
    ACCESS_TOKEN: (realm) => `/realms/${realm}/protocol/openid-connect/token`,
    OTP_ACCESS_TOKEN: (realm) => `/realms/${realm}/custom-api/generate-token`,
    VERIFY_OTP: (realm) => `/realms/${realm}/custom-api/verify-otp`,
    RESEND_OTP: (realm) => `/realms/${realm}/custom-api/resend-otp`,
    FORGOT_PASSWORD: (realm) => `/realms/${realm}/custom-api/forget-password`,
    RESET_PASSWORD: (realm) => `/realms/${realm}/custom-api/reset-password`,
    CHANGE_PASSWORD: (realm) => `/realms/${realm}/custom-api/change-password`,
    REVOKE_ACCESS_TOKEN: (realm) => `/realms/${realm}/protocol/openid-connect/revoke`,
    INTROSPECT_ACCESS_TOKEN: (realm) => `/realms/${realm}/protocol/openid-connect/token/introspect`,
};
